import React, { Component } from 'react';
import { isClient } from 'frontend/helpers/ssr-helper';
import Moment from 'moment';
import Transporte from './detalle-amichi/paquete-detalle-transporte/paquete-detalle-transporte';
import ServiciosIncluidos from './detalle-amichi/servicios-incluidos/servicios-incluidos';
import Hoteles from './detalle-amichi/paquete-detalle-hoteles/paquete-detalle-hoteles';
import PanelOperador from '../paquetes-detalle/panel-operador/panel-operador';
import Incluye from './detalle-amichi/paquete-detalle-incluye/paquete-detalle-incluye';

class DetalleAmichi extends Component {
  constructor(props) {
    super(props);
    this.formatearPrecio = this.formatearPrecio.bind(this);
    this.armarDescripcionMeta = this.armarDescripcionMeta.bind(this);

    this.armarDatos = this.armarDatos.bind(this);
  }

  formatearPrecio(precioNeto, impuestos, iva, cantPasajeros) {
    let precioRedondeado = 0;
    if (cantPasajeros > 0) {
      precioRedondeado = Math.ceil(
        (precioNeto + impuestos + iva) / cantPasajeros,
      );
    } else {
      precioRedondeado = Math.ceil(precioNeto + impuestos + iva);
    }

    return this.formatNumber(precioRedondeado);
  }

  armarDatos() {
    const url = this.armarUrl();
    return {
      idProveedor: url.searchParams.get('p'),
      IdSalida: url.searchParams.get('t'),
      distribucion: url.searchParams.get('h'),
    };
  }

  armarUrl = () => {
    const urlString = isClient ? window.location.href : '';
    return new URL(urlString);
  }

  formatNumber = (num) => {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
  }

  armarDescripcionMeta() {
    const cantPasajeros
            = this.props.paquete.pasajeros !== null ? this.props.paquete.pasajeros.length > 0 ? this.props.paquete.pasajeros.length : this.props.cantidadPasajeros : '1';

    const precio = this.formatearPrecio(
      this.props.paquete.salidas[0].precios.precioNeto,
      this.props.paquete.salidas[0].precios.impuestos,
      this.props.paquete.salidas[0].precios.iva,
      cantPasajeros,
    );

    const fechaSalida = Moment(this.props.paquete.salidas[0].fechaSalida).format(
      'DD/MM/YYYY',
    );

    return `ARS ${precio} - Fecha de salida ${fechaSalida}`;
  }

  renderizarDetalle() {
    const transporte = this.props.paquete.salidas[0].transporte.transporteAereo.itinerarioVuelo === null ? '' : <Transporte transporte={this.props.paquete.salidas[0].transporte} ida={this.props.paquete.salidas[0].transporte.transporteAereo.itinerarioVuelo.informeIda} vuelta={this.props.paquete.salidas[0].transporte.transporteAereo.itinerarioVuelo.informeVuelta} />;
    const cantPasajeros
            = this.props.paquete.pasajeros !== null ? this.props.paquete.pasajeros.length > 0 ? this.props.paquete.pasajeros.length : this.props.cantidadPasajeros : '1';

    // eslint-disable-next-line no-unused-vars
    const precio = (this.props.paquete.salidas[0].precios.precioNeto + this.props.paquete.salidas[0].precios.impuestos + this.props.paquete.salidas[0].precios.iva) / cantPasajeros;

    return (
      <div>
        <div className='listado-paquetes'>
          <div className='detalle paquete'>
            <div className='container'>
              <br />
              {transporte}
              <ServiciosIncluidos
                descripcion={this.props.paquete.salidas[0].servicios}
                iconos={this.props.paquete.salidas[0].tipoServicios}
              />
              <Hoteles
                destinos={this.props.paquete.salidas[0].destinosHoteles}
                hoteles={this.props.paquete.salidas[0].hoteles}
              />
              {this.props.paquete.metaDescripcion !== null && (
                <Incluye descripcion={this.props.paquete.metaDescripcion} />
              )}
              <PanelOperador
                datos={this.props.paquete.operadorResponsable}
              />
            </div>
          </div>
          <div className='clearfix' />
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        { this.renderizarDetalle()}
      </div>
    );
  }
}

export default DetalleAmichi;
